export const ACCOUNTS_PATH = "/platform/accounts";

export const accountHolderPath = (accountId: string) =>
  `${ACCOUNTS_PATH}/${accountId}`;
